'use strict'

const { selectCurrentRecord } = require('../../dataset-controller/rootReducer')

module.exports = ({
  getState,
  services
}) => {
  const itemReady = (actions, api, component) => (scoped$w, itemData, index) => {
    const scopeId = {componentId: component.uniqueId, itemId: itemData._id}
    const {scopeStore, scopeFactory} = services()
    const scope = scopeFactory.createFixedItemScope(scopeId, itemData)
    scopeStore.setScope(scopeId, scope)
    scope.pageReady(scoped$w.scoped)
  }

  const itemRemoved = component => itemData => {
    const scopeId = {componentId: component.uniqueId, itemId: itemData._id}
    services().scopeStore.removeScope(scopeId)
  }

  const refreshView = async (
    { connectionConfig: { properties }, component },
    actions
  ) => {
    const { items: newItems } = await actions.fetchCurrentItems(getState())

    component.data = newItems
  }

  return {
    isValidContext({ connectionConfig }) {
      return true
    },

    bindToComponent(
      { connectionConfig: { properties, events, filters }, component },
      actions,
      api
    ) {
      component.onItemReady(itemReady(actions, api, component))
      component.onItemRemoved(itemRemoved(component))
    },

    currentRecordModified({ component }, actions, updatedFields) {
      const updatedItem = selectCurrentRecord(getState())
      const existingItems = component.data || []

      const newItems =
        existingItems.map(
          existingItem =>
            existingItem._id === updatedItem._id
            ? updatedItem
            : existingItem)
      component.data = newItems
    },

    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/repeater/connectedRepeaterAdapter.js